import { isNumber } from 'lodash-es';

import { MAX_IN_RESTAURANT_CART_QUANTITY, MIN_IN_RESTAURANT_CART_QUANTITY } from './constants';

export const isQuantityValid = (quantity: unknown) =>
  isNumber(quantity) &&
  quantity <= MAX_IN_RESTAURANT_CART_QUANTITY &&
  quantity >= MIN_IN_RESTAURANT_CART_QUANTITY;

/**
 * Removes the element at the given index from the list.
 */
export const removeElementAtIndexFromList = (array: Array<any>, elementIndex: number) => {
  if (elementIndex < 0) {
    return array;
  }

  return array.slice(0, elementIndex).concat(array.slice(elementIndex + 1, array.length));
};
